import React from 'react';
import Checkout from '../components/Checkout';

const CheckoutPage = () => {
  return <Checkout />;
};

export default CheckoutPage;

